import { OutlineButton } from "components/Buttons/OutlineButton";
import Card from "components/Card/Card";
import React from "react";
import { CardTitle } from "./Topup";

export default function PricingCard({ plan, onSelected }) {
  return (
    <Card radius={20} padding={"0px 20px"}>
      <div style={{ alignItems: "right", alignSelf: "flex-end" }}>
        <div
          style={{
            backgroundColor: "orange",
            color: "white",
            margin: "0px 10px",
            padding: "10px 20px",
            borderRadius: "0px 0px 10px 10px"
          }}
        >
          {plan.price.replace(" ", "\n")}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: 400
        }}
      >
        <CardTitle>{plan.name}</CardTitle>
        <span
          style={{
            fontSize: 20,
            marginTop: 20,
            marginBottom: 20,
            fontWeight: "bold"
          }}
        >
          {plan.exams} Exams
        </span>
        <span
          style={{
            color: "grey",
            marginTop: 10,
            marginBottom: 10
          }}
        >
          {plan.detail}
        </span>

        <OutlineButton onClick={() => onSelected()}>Buy Now</OutlineButton>
      </div>
    </Card>
  );
}
